import React, { useMemo, useState } from 'react';
import { Box, Tooltip } from '@mui/material';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import InitiativesTable from '../InitiativesTable';
import GrowthForm from './GrowthForm';
import { GROWTH_MOCK } from '../mockData';
import '../initiatives.scss';

const TABLE_COLUMNS = [
  { key: 'project_objective', label: 'Project Objective', width: '12%' },
  { key: 'project_id', label: 'Project ID', width: '10%' },
  { key: 'project_description', label: 'Project Description', width: '28%' },
  { key: 'account_owner', label: 'Account Owner', width: '16%' },
  { key: 'account_owner_title', label: 'Title', width: '12%' },
  { key: 'report_to', label: 'Report To', width: '14%' },
  { key: 'report_to_title', label: 'Title', width: '10%' },
];

const GrowthPage = () => {
  const [rows, setRows] = useState(GROWTH_MOCK.row_data);
  const [editMode, setEditMode] = useState(false);
  const [formMode, setFormMode] = useState('create');
  const [editData, setEditData] = useState({});

  const columns = useMemo(() => TABLE_COLUMNS, []);

  const handleAdd = () => {
    setFormMode('create');
    setEditData({});
    setEditMode(true);
  };

  const handleProjectClick = (row) => {
    setFormMode('edit');
    setEditData(row);
    setEditMode(true);
  };

  const handleSave = (payload) => {
    setRows((prev) => {
      const idx = prev.findIndex((r) => r.project_id === payload.project_id);
      if (idx >= 0) {
        const next = [...prev];
        next[idx] = { ...next[idx], ...payload };
        return next;
      }
      const projectId =
        payload.project_id || `G${prev.length + 1}-FY27`;
      return [{ ...payload, project_id: projectId }, ...prev];
    });
    setEditMode(false);
  };

  return (
    <div className="initiatives-jklc">
      {editMode ? (
        <GrowthForm
          mode={formMode}
          initialData={editData}
          onBack={() => setEditMode(false)}
          onSave={handleSave}
        />
      ) : (
        <Box>
          <Box className="initiatives-jklc__toolbar">
            <Tooltip title="Create Initiatives">
              <button
                type="button"
                className="initiatives-jklc__create-btn"
                onClick={handleAdd}
              >
                <AddCircleOutlineIcon fontSize="small" />
                Initiatives
              </button>
            </Tooltip>
          </Box>
          <InitiativesTable
            columns={columns}
            rows={rows}
            onProjectClick={handleProjectClick}
          />
        </Box>
      )}
    </div>
  );
};

export default GrowthPage;
